export default __webpack_public_path__ + "static/media/Chevron-chev.f59b0d01.svg";